import script from "./ApiSelect.vue?vue&type=script&lang=ts&setup=true&name=ApiSelect"
export * from "./ApiSelect.vue?vue&type=script&lang=ts&setup=true&name=ApiSelect"

const __exports__ = script;

export default __exports__